import { Select as SelectInput } from './Select';
import { wrapInLabel } from '../NewInputLabelWrapper';
import styles from './Select.module.scss';
import { withFormMeta } from '../../FormMeta';

export default withFormMeta(wrapInLabel(SelectInput, { error: styles.reactSelectError }));
